export default function settings(state = {table: []}, action) {
    switch (action.type) {
        case "SETTINGS_TABLE_REQUEST":
            return state
        case "SETTINGS_TABLE":
            return {
                ...state,
                table: action.payload
            }
        default:
            return state
    }
}
